<template>
  <div class="content bg-light">
    <div class="row p-sm-5 pt-3">
      <div class="col">
        <div class="alert alert-info fs-3" role="alert" v-if="newSession">
          <span class="welcom-text"></span>
        </div>
        <div class="alert alert-info fs-3" role="alert" v-else>
          Bienvenue sur la plateforme de candidature de PREFERE PLUS!
        </div>
        <div class="alert alert-success fs-3 text-center" role="alert">
          Les candidatures sont ouvertes. <br> <i>Retrouvez les offres d'emplois disponibles ci-dessous.</i>
        </div>

        <!-- Section des offres d'emploi -->
        <div class="job-offers-section mt-4">
          <h4 class="section-title text-uppercase mb-4">Offres d'emploi disponibles</h4>
          
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Chargement...</span>
            </div>
          </div>
          
          <div v-else-if="jobOffers.length === 0" class="alert alert-info">
            Aucune offre disponible pour le moment.
          </div>
          
          <div v-else class="row">
            <div v-for="offer in jobOffers" :key="offer.id" class="col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-header bg-primary text-white">
                  <h5 class="mb-0">{{ offer.title }}</h5>
                </div>
                <div class="card-body">
                  <p class="text-muted small mb-2">
                    <i class="fas fa-calendar-alt me-2"></i>
                    Date limite : {{ formatDate(offer.deadline) }}
                  </p>
                  <!-- Show description as plain text, not raw HTML -->
                  <p class="card-text">{{ truncateDescription(stripHtmlTags(offer.description)) }}</p>
                  <div class="mt-3">
                    <router-link 
                      :to="`/jobs/${offer.id}/apply`"
                      class="btn btn-sm btn-outline-primary"
                    >
                      Postuler maintenant
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="alert alert-warning fs-5 mt-4" role="alert">
          <h4 class="alert-heading fw-bold mb-3">⚠️ ATTENTION</h4>
          <p>Le cabinet PREFERE PLUS ne perçoit aucun frais de quelque nature que ce soit de la part des candidats tout au long du processus de recrutement (dépôt de candidature, étude du CV, entretien d'embauche et traitement final des candidatures).</p>
          <p>En outre, le cabinet ne demande aucune information sur les comptes bancaires des candidats.</p>
          <p class="mb-0">Le cabinet décline toute responsabilité de publications frauduleuses d'offres d'emploi en son nom ou, de manière générale, d'utilisation frauduleuse de son nom de quelque manière que ce soit.</p>
        </div>

        <div class="col mt-5 mb-4">
          <h4 class="section-title text-uppercase">SECTION INFO</h4>
        </div>
        <div
          class="card border-info mb-3"
          v-for="info in informations"
          :key="info.id"
        >
          <div class="card-body ql-editor">
            <p class="card-text" v-html="info.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Typed from "typed.js";

export default {
  name: "Home",
  mounted() {
    if (localStorage.getItem("candidature_step")) {
      this.preselected = localStorage.getItem("candidature_step") == 4;
      this.selected = localStorage.getItem("candidature_step") == 5;
    }

    this.getInformations();
    this.getUser();
    this.loadJobOffers();
    document.querySelector("body").style.backgroundColor = "#f8f9fa";
  },
  data() {
    return {
      informations: {},
      newSession: this.$store.state.newSession,
      jobOffers: [],
      loading: true
    };
  },
  methods: {
    getInformations() {
      this.$http.get("announcements").then((result) => {
        this.informations = result.data;
      });
    },
    getUser() {
      this.$http.get("users/000").then((result) => {
        localStorage.setItem("candidature_step", result.data.step);

        if (this.newSession) {
          this.$store.commit("updateSession");
          var options = {
            strings: [
              `Bonjour ${result.data.first_name}.`,
              "Bienvenue sur la plateforme de candidature de PREFEREPLUS!",
            ],
            typeSpeed: 40,
            startDelay: 1005,
            backDelay: 1005,
            backSpeed: 40,
          };

          new Typed(".welcom-text", options);

          sessionStorage.setItem("new_session", "false");
        }
      });
    },
    async loadJobOffers() {
      try {
        const response = await this.$http.get('/jobs')
        this.jobOffers = response.data.job_offers.data.filter(offer => 
          offer.is_active && !this.isExpired(offer.deadline)
        )
      } catch (error) {
        console.error('Erreur lors du chargement des offres:', error)
        if (error.response?.status === 401) {
          // Rediriger vers la connexion si non authentifié
          this.$router.push('/login')
        }
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },
    isExpired(date) {
      return new Date(date) < new Date()
    },
    // This method removes all HTML tags to safely display description as text only
    stripHtmlTags(html) {
      if (!html) return ''
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    truncateDescription(description) {
      if (!description) return ''
      return description.length > 150 
        ? description.substring(0, 150) + '...' 
        : description
    },
    postuler(offerId) {
      if (this.$store.state.isAuthenticated) {
        this.$router.push(`/jobs/${offerId}/apply`);
      } else {
        this.$router.push('/login');
      }
    }
  },
};
</script>

<style scoped>
@import "../assets/styles/quill.core.css";
.container {
  background-color: #80808096;
}

.content {
  padding-left: 20px; 
  padding-right: 20px;
}

.section-title {
  border-bottom: 3px solid #3490dc;
}

.job-offers-section .card {
  transition: transform 0.2s;
}

.job-offers-section .card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

@media (min-width: 992px) {
  .content {
    padding-left: 150px; 
    padding-right: 150px;
  }
}
</style>
